import { usePresence } from '../../../components/Presence/usePresence';
import type { PresenceViewer } from '../../../components/Presence/PresenceContract';
import type { SelectedItem } from '../Components/AppArtifactPanel';

export type DesignerViewer = PresenceViewer;

export function useAppDesignerPresence(definitionId: string | undefined, scope: string, selectedItem: SelectedItem | null, sharedComponentId?: string) {
	return usePresence('app', definitionId, scope, selectedItem ? {
		itemType: selectedItem.type,
		itemId: selectedItem.id,
		relatedItemType: sharedComponentId ? 'sharedComponent' : undefined,
		relatedItemId: sharedComponentId,
	} : null);
}
